import { render } from "./EmployeeCardSmall.vue?vue&type=template&id=21703da8&scoped=true&bindings={}"
import script from "./EmployeeCardSmall.vue?vue&type=script&lang=ts"
export * from "./EmployeeCardSmall.vue?vue&type=script&lang=ts"

import "./EmployeeCardSmall.vue?vue&type=style&index=0&id=21703da8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-21703da8"

export default script